import { useQuery } from '@apollo/client';
import { useCustomSnackbar } from '@procureai/ui-mui';

import { useDemandDetail } from '~/modules';

import { DEMAND_FILES_QUERY } from './DemandDocuments.query.gql';

export const useDemandDocuments = (demandId?: string) => {
  const { demandId: urlDemandId } = useDemandDetail();
  const { onError } = useCustomSnackbar();
  const { data, loading } = useQuery(DEMAND_FILES_QUERY, {
    variables: { id: demandId ?? urlDemandId },
    fetchPolicy: 'cache-first',
    onError,
  });

  const files = data?.tesseract.demand.files ?? [];

  return { demandId, files, loading };
};
